import { useState } from "react";

const RadioButtons = ({ tabs, activeTab, setActiveTab }) => {

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    // onTabClick(tabName);
  };

  return (
    <div className="content flex-row-fluid" style={{height:'5rem',display:'flex',alignItems:'center',paddingLeft:'1.1rem',}}>
      <div>
        <div className="col-xl-4 mb-xl-10">
          <div className="h-md-50">
            <div className="card-body ps-0 pb-0" style={{ width: '45rem' }}>
              <ul
                className="nav nav-pills nav-pills-custom"
                style={{ display: 'flex', gap: '10px', listStyle: 'none', padding: 0,}}
              >
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab}>
                    <a
                      className="nav-link d-flex justify-center flex-col items-center w-20 h-20 py-3 mt-3"
                      style={
                        activeTab === tab
                          ? { backgroundColor: '#6D9300', border: '2px solid #6D9300', borderRadius: '8px' , color:'white'}
                          : {color:'#000'}
                      }
                      href="#"
                      onClick={() => handleTabClick(tab)}
                    >
                      <span className="nav-text font-bold text-sm">{tab}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RadioButtons;